import { useEffect, useState } from "react";
import axios from "axios";

const CorporateActionDropDown = ({ setValue }) => {
  const handleAction = (e) => {
    setValue((prev) => ({
      ...prev,
      ["action"]: e.target.value,
    }));
  };

  return (
    <div className="flex h-full  w-full flex-col gap-2 rounded-[4px] bg-gray-100">
      <div className="h-full rounded bg-transparent px-[1px] py-[1px]">
        <select
          className=" w-full  bg-transparent py-[0.4rem] text-[14px] text-[#868686]  focus:outline-none"
          defaultValue={true}
          onChange={(e) => handleAction(e)}
        >
          <option value="" className="">
            Select Corporate Action
          </option>
          <option value="B" className="">
            Bonus
          </option>
          <option value="S" className="">
            Split
          </option>
          <option value="R" className="">
            Reduction
          </option>
          <option value="C" className="">
            Consolidation
          </option>
          <option value="A" className="">
            Merger
          </option>
          <option value="X" className="">
            Demerger
          </option>
          <option value="D" className="">
            Dividend
          </option>
          <option value="G" className="">
            Right
          </option>
        </select>
      </div>
    </div>
  );
};

export default CorporateActionDropDown;
